import { useEffect } from 'react';

// Per-route meta without a new dependency: updates document title,
// description, and social tags client-side. Canonical/og:url are
// intentionally omitted until the production domain is confirmed.
const upsert = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export default function Seo({ lang, title, description }) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    upsert('name', 'description', description);
    upsert('property', 'og:title', title);
    upsert('property', 'og:description', description);
    upsert('property', 'og:locale', lang === 'id' ? 'id_ID' : 'en_US');
    upsert('name', 'twitter:title', title);
    upsert('name', 'twitter:description', description);
  }, [lang, title, description]);
  return null;
}
